<template>
  <Modal
    class="cc-modal"
    width="500"
    footer-hide
    v-model="visibility"
    :title="data.type == 0 ? '微信支付' : '支付宝支付'"
  >
    <div class="content" v-if="data">
      <iframe :srcdoc="html"
              frameborder="no"
              border="0"
              marginwidth="0"
              marginheight="0"
              scrolling="no"
              width="200"
              height="200"
              style="overflow:hidden;">
      </iframe>
    </div>
    <div class="foot">
      <Button @click="onCancel">选择其他支付方式</Button>
    </div>
  </Modal>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
  name: "userImageModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      html: ''
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.qrCodeUrl) this.bindQRCode(val);
      },
    },
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    // 二维码
    bindQRCode(val) {
      if (val.type == 0) {
        if (this.code) {
          this.$refs.qrCodeDiv.innerHTML = "";
          this.code.clear();
        }
        this.code = new QRCode(this.$refs.qrCodeDiv, {
          text: val.qrCodeUrl,
          width: 160,
          height: 160,
          colorDark: "#333333", // 二维码颜色
          colorLight: "#ffffff", // 二维码背景色
          correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
        });
      } else {
        this.html = val.qrCodeUrl
      }

    },
    onCancel() {
      this.visibility = false;
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 220px;
    max-height: 500px;
    overflow: auto;
    text-align: center;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.row {
  display: flex;
  line-height: 40px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
}
.code-area {
  width: 160px;
  height: 160px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  background-color: #f7f7f7;
  margin: 0 auto 20px;
}
</style>
